import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    ListItemButton, ListItemText,
    Step,
    StepLabel,
    Stepper,
    Tooltip
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ButtonExit from "../../../button/ButtonExit";
import UploadFilesRequestsForm from "../../../../../pages/organization/orders/estimate/UploadFilesRequestsForm";
import FileService from "../../../../../API/orders/orders/customer/FileService";
import MaterialTree from "../../../tree/MaterialTree";
import GroupMaterialUtil from "../../../../../utils/orders/GroupMaterialUtil";
import {useNavigate} from "react-router-dom";
import ButtonBack from "../../../button/ButtonBack";
import ButtonAdd from "../../../button/ButtonAdd";

const steps = [
    'Группа',
    'Импорт',
];

const ModalImport = ({
                         open,
                         onClose,
                         handleModalAlert,
                         initValueGroup,
                         materialTreeData,
                         handleActiveItemsChange,
                         setData
                     }) => {
    const navigate = useNavigate();
    const [change, setChange] = useState(false);
    const [activeStep, setActiveStep] = useState(0)

    const [currentGroup, setCurrentGroup] = useState(initValueGroup);
    const [filterGroup, setFilterGroup] = useState(new Map());
    const [changeFilterGroup, setChangeFilterGroup] = useState(false);
    const [expandedItems, setExpandedItems] = useState(['M']);

    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
    };

    const handleToggle = (node) => {
        let id = node?.id

        const group = materialTreeData?.groupMap?.get(id) || {}
        if (group !== null) {
            GroupMaterialUtil.addToFilterMapGroup(group, filterGroup)
            setFilterGroup(filterGroup);
            setChangeFilterGroup(!changeFilterGroup)
            setCurrentGroup(group)
        }
    };
    useEffect(() => {
        setCurrentGroup(initValueGroup)
    }, [initValueGroup])

    const redirectGroups = () => {
        if (handleActiveItemsChange) {
            handleActiveItemsChange("systemSamplesGroup")
        } else {
            navigate('/customer/groups')
        }
    }
    const handleClose = () => {
        onClose()
        setActiveStep(0)
        setCurrentGroup(null)
    }
    const handleBeforeImport = (data) => {
        setData(value => [...value, ...data])
        handleClose()
    }

    const dataTree = materialTreeData?.dataTree ?? [];

    return <Dialog open={open} PaperProps={{
        style: {
            minWidth: activeStep === 0 ? "400px" : `630px`,
        }
    }}>
        <Box style={{
            padding: 20,
            display: "flex",
            flexDirection: "column",
            gap: 16,
            justifyContent: "space-between",
            alignItems: "center"
        }}>
            <DialogTitle textAlign="center">Добавить из файла</DialogTitle>
            <Stepper
                style={{width: 446}}
                activeStep={activeStep}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel sx={{
                            ".MuiSvgIcon-root": {
                                fontSize: 40,
                                color: "#737478",
                                "&.Mui-active": {
                                    color: "#3B8BEC",
                                }
                            },
                            "& .MuiStepLabel-label": {
                                fontSize: 18,
                                "&.Mui-active": {
                                    fontWeight: 700,
                                }
                            }
                        }}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
        <DialogContent sx={{minWidth: 300}}>
            {activeStep === 0 ?
                <Box sx={{padding: "0 40px"}}>
                    <MaterialTree
                        name={"Группы"}
                        data={dataTree}
                        currentGroup={currentGroup}
                        setCurrentGroup={setCurrentGroup}
                        handleToggle={handleToggle}
                        expandedItems={expandedItems}
                        handleExpandedItemsChange={handleExpandedItemsChange}
                    />
                    {dataTree.length === 0 && <Box>
                        <ListItemButton
                            sx={{
                                color: "#006CCC",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                    textDecoration: "underline",
                                }
                            }}
                            onClick={redirectGroups}
                        ><ListItemText
                            primary={"Необходимо добавить группу"}/>
                        </ListItemButton>
                    </Box>}
                </Box>
                :
                <UploadFilesRequestsForm
                    orderId={null}
                    detail={true}
                    change={change}
                    setChange={setChange}
                    calculationRequestsCutting={false}
                    uploadData={{
                        id: 1,
                        helpText: "Импорт деталей из файла",
                        upload: FileService.uploadDetailSamples
                    }}
                    handleModalAlert={handleModalAlert}
                    importDetailSamplesGroup={currentGroup?.id}
                    beforeImport={handleBeforeImport}
                />}
        </DialogContent>
        <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
            <Box>{activeStep !== 0 &&
                <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
            <Box>
                <ButtonExit text={"Закрыть"} onClick={handleClose}/>
                {activeStep === 0 &&
                    <ButtonAdd text={"Выбрать"} onClick={() => setActiveStep(1)} disabled={!currentGroup?.id}/>}
            </Box>
        </DialogActions>
    </Dialog>
}
export default ModalImport